import React from 'react';
import PropTypes from 'prop-types';
import AutoCompleteFilter from './AutoCompleteFilter';

const ProductFilter = (props) => {
    const {
        optionValue,
        searchBy,
        source,
        ...restProps
    } = props;

    return (
        <AutoCompleteFilter
            label='filters.components.productId.label'
            options={ {
                fullWidth: true,
            } }
            optionValue={ optionValue }
            reference='products'
            searchBy={ searchBy }
            searchParams={ {
                size: '12',
                sort_by: 'title',
                sort_direction: 'asc',
            } }
            source={ source }
            { ...restProps }
        />
    );
};

ProductFilter.defaultProps = {
    optionValue: 'id',
    searchBy: 'title',
    source: 'product_id',
};

ProductFilter.propTypes = {
    optionValue: PropTypes.string,
    searchBy: PropTypes.string,
    source: PropTypes.string,
};

export default ProductFilter;


// WEBPACK FOOTER //
// ./src/components/list/Filters/types/ProductFilter.js